import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BriefingMasterModel } from 'src/Models/BriefingMasterModel';
import { ToolEnum } from 'src/Models/Common';
import { BriefingEmailDataByBriefingIdModel, ExportEmailForBriefingModel } from 'src/Models/ExportEmailForBriefingModel';
import { I360Service } from 'src/Services/i360Service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-briefing-email-details',
  templateUrl: './briefing-email-details.component.html',
  styleUrls: ['./briefing-email-details.component.css']
})
export class BriefingEmailDetailsComponent implements OnInit {

  briefingForm: FormGroup;
  briefingId: number = 0;

  productId: number = 1;
  tokenKey: string = '';
  SelectedTool: string;
  currentPage: number = 1;
  pageSize:number=10;
  totalRecordCount: number = -1;

  systemUserCondition: string = '';
  isSendEmailNotificationChecked: boolean = false;
  isShowprogressSpinner: boolean = false;
  blockedDocument: boolean = false;
  isMultipleClick: boolean = false;

  briefingMasterModel = new BriefingMasterModel();
  updateDate: string;
  title: string;
  description: string;
  listOfBriefing: ExportEmailForBriefingModel[];
  listOfExportBriefing: ExportEmailForBriefingModel[];
  isEmailData: boolean = false;
  fromSummary: any;

  totalEmail:number=0;
  totalSentEmail:number=0;
  totalInprogressEmail:number=0;
  totalFailedEmail:number=0;

  fltbrifingData = new BriefingEmailDataByBriefingIdModel();

  constructor(private readonly router: Router, 
    private readonly checkAuth: CheckAuth, 
    private readonly activedRoute: ActivatedRoute, 
    private readonly i360service: I360Service,
    private readonly toastr: ToastrService, 
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Briefing Details');
  }

  ngOnInit() {
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {
          this.briefingId = params['id'];
          this.GetBriefingData();
          this.GetBriefingEmailDataByBriefingId(this.briefingId);
          this.fromSummary = sessionStorage.getItem("fromSummary");
        }
      }
    });
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  GetBriefingEmailDataByBriefingId(id) {
    // this.isShowprogressSpinner = true;
    // this.blockedDocument = true;
    this.fltbrifingData.brifingId=this.briefingId;
    this.fltbrifingData.currentPage=this.currentPage;
    this.fltbrifingData.pageSize=this.pageSize;
    this.fltbrifingData.isExport=false;

    this.i360service.GetBriefingEmailDataByBriefingId(this.tokenKey, this.fltbrifingData).subscribe(
      res => {
        if (res != null) {
          if (res.status == "Success") {
            this.listOfBriefing = res["emailData"];
            if (this.listOfBriefing.length > 0) {
              this.totalRecordCount = this.listOfBriefing[0].totalRecordCount;
              this.isEmailData = true;
            } else {
              this.isEmailData = false;
              this.totalRecordCount = 0;
            }
          }

          // this.isShowprogressSpinner = false;
          // this.blockedDocument = false;
        }
        else {
          // this.isShowprogressSpinner = false;
          // this.blockedDocument = false;
        }

      }, error => {
        // this.isShowprogressSpinner = false;
        // this.blockedDocument = false;
        this.totalRecordCount = 0;
        console.log(error);
      }
    );
  }

  sendEmail(id) {
    this.blockedDocument = this.isShowprogressSpinner = true;

    this.i360service.BriefingInstantEmailSendById(this.tokenKey, id).subscribe(
      data => {
        this.blockedDocument = this.isShowprogressSpinner = false;
        if (data != null) {
          if (data.status == 'Success') {
            this.toastr.success('Mail send successfully.', 'Success')
            this.GetBriefingEmailDataByBriefingId(id);
          }
          else {
            this.toastr.error(data.message, 'Error')
            this.GetBriefingEmailDataByBriefingId(id);
          }
        }
      },
      error => {
        this.blockedDocument = this.isShowprogressSpinner = false;
      }
    );
  }

  GetBriefingData(): void {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.i360service.i360BriefingMasterFindbyBriefingId(this.tokenKey, this.briefingId).subscribe(
      data => {
        if (data != null) {
          this.briefingMasterModel = data["briefingData"];
          if (this.briefingMasterModel != null) {

            this.briefingId = this.briefingMasterModel.briefingId;
            this.updateDate = this.dateFormat(new Date(this.briefingMasterModel.updateDate));
            this.title = this.briefingMasterModel.title;
            this.description = this.briefingMasterModel.description;

            let EmailStatus = this.briefingMasterModel.emailStatus;
            this.totalEmail = this.briefingMasterModel.totalEmailCount;

            if (EmailStatus == "Pending") {
              this.totalSentEmail = 0;
              this.totalFailedEmail = 0;
              this.totalInprogressEmail = 0;
            }
            else {
              this.totalSentEmail = this.briefingMasterModel.emailSentCount;
              this.totalFailedEmail = this.briefingMasterModel.emailFailedCount;
              this.totalInprogressEmail = this.totalEmail - this.totalSentEmail - this.totalFailedEmail;
            }

            this.isShowprogressSpinner = false;
            this.blockedDocument = false;
          }
          else {
            this.isShowprogressSpinner = false;
            this.blockedDocument = false;
          }
        }
      }, error => {
        this.isShowprogressSpinner = false;
        this.blockedDocument = false;
        this.showMessage(error, 'Error', 'error');
      })
  }

  cancelBriefingServices() {
    if (this.fromSummary == "0")
      this.router.navigate(['admin/briefingServices/list']);
    else
      this.router.navigate(['admin/briefingServices/emailSummary']);
  }

  dateFormat(dt: Date) {
    let dd = dt.getDate().toString();
    if (parseInt(dd.toString()) < 10)
      dd = '0' + dd.toString();

    let mm = (dt.getMonth() + 1).toString();
    if (parseInt(mm.toString()) < 10)
      mm = '0' + mm.toString();

    return mm + '/' + dd + '/' + dt.getFullYear() + ' 00:00:00';
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.GetBriefingEmailDataByBriefingId(this.briefingId);
  }

  
  ExportBriefingEmailDataByBriefingId() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
    this.fltbrifingData.brifingId=this.briefingId;
    this.fltbrifingData.currentPage=this.currentPage;
    this.fltbrifingData.pageSize=this.pageSize;
    this.fltbrifingData.isExport=true;

    this.i360service.GetBriefingEmailDataByBriefingId(this.tokenKey, this.fltbrifingData).subscribe(
      res => {
        if (res != null) {
          if (res.status == "Success") {
            this.listOfExportBriefing = res["emailData"];

            setTimeout(() => {
              this.exportToExcel();
            }, 1000);
          }

          this.isShowprogressSpinner = false;
          this.blockedDocument = false;
        }
        else {
          this.isShowprogressSpinner = false;
          this.blockedDocument = false;
        }

      }, error => {
        this.isShowprogressSpinner = false;
        this.blockedDocument = false;
        console.log(error);
      }
    );
  }

  exportToExcel() {
      let tableData = document.getElementById("ExportData").innerHTML;
  
      var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
        , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }    
      let html = "<table><tr class='mainhead'> <td colspan='3'>";
      html += tableData;
      html += "</td></tr></table>";    
      let name = 'Briefingdetails';
      var ctx = { worksheet: name || 'Worksheet', table: html }
      FileSaver.saveAs((uri + base64(format(template, ctx))), name+".xls");
    }
}
